import { render } from "./StorefrontPasswordPage.vue?vue&type=template&id=9e9df014&scoped=true"
import script from "./StorefrontPasswordPage.vue?vue&type=script&lang=js"
export * from "./StorefrontPasswordPage.vue?vue&type=script&lang=js"

import "./StorefrontPasswordPage.vue?vue&type=style&index=0&id=9e9df014&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e9df014"]])

export default __exports__